<template>
  <div class="pt-5">
    <SimpleSectionHeader
      title="Notre engagement pour un numérique responsable"
      class="pb-0 tw-pt-30"
      isSectionTitle
    />

    <div class="container section-politiques">
      <CardWithLineGeneric>
        <template v-slot:title>
          <vue-feather type="check" class="tw-text-orange-500 me-3" />
          Soutenir durablement, agir résolument
        </template>
        <template v-slot:body>
          <div class="tw-flex tw-gap-3 tw-flex-col tw-text-slate-500 tw-text-justify">

            <div>
              Dans un monde marqu&eacute; par les crises climatiques, les tensions
              g&eacute;opolitiques et l&apos;essor rapide de l&apos;intelligence
              artificielle, les entreprises du num&eacute;rique ont une
              responsabilit&eacute; particuli&egrave;re. Plus que jamais,
              l&apos;innovation doit s&apos;accompagner d&apos;une exigence de
              responsabilit&eacute;, de r&eacute;silience et de confiance.
            </div>
            <div>
              Chez Worldata Team, nous accompagnons nos clients dans leurs
              transformations num&eacute;riques avec la conviction que la
              performance durable repose autant sur la qualit&eacute; des
              solutions que sur la mani&egrave;re dont elles sont con&ccedil;ues
              et d&eacute;ploy&eacute;es. Les technologies que nous
              d&eacute;veloppons doivent cr&eacute;er de la valeur tout en
              respectant les personnes, les droits fondamentaux et
              l&apos;environnement.
            </div>
            <div>
              Membre du Pacte mondial des Nations Unies depuis 2021, Worldata Team
              renouvelle son engagement en faveur des 10 principes relatifs aux
              droits humains, aux normes internationales du travail, &agrave; la
              protection de l&apos;environnement et &agrave; la lutte contre la
              corruption. Cet engagement guide progressivement nos politiques, nos
              pratiques et nos d&eacute;cisions.
            </div>
            <div>
              Il se traduit notamment par une gouvernance fond&eacute;e sur
              l&apos;&eacute;thique, un dispositif d&apos;alerte interne, la
              sensibilisation de nos collaborateurs &agrave;
              l&apos;int&eacute;grit&eacute;, ainsi qu&apos;une attention
              constante port&eacute;e &agrave; la protection des donn&eacute;es,
              &agrave; la cybers&eacute;curit&eacute; et au respect des exigences
              r&eacute;glementaires.
            </div>
            <div>
              Notre responsabilit&eacute; s&apos;exprime &eacute;galement &agrave;
              travers notre politique sociale. Nous veillons &agrave; offrir un
              environnement de travail respectueux, inclusif et propice au
              d&eacute;veloppement des comp&eacute;tences. Nous poursuivons nos
              actions en faveur de l&apos;&eacute;galit&eacute; professionnelle,
              du dialogue social, de la qualit&eacute; de vie au travail et de
              l&apos;accompagnement de nos collaborateurs, convaincus que
              l&apos;engagement des &eacute;quipes constitue le premier levier
              d&apos;une croissance durable.
            </div>
          
            <div>
              L&apos;intelligence artificielle occupe une place grandissante dans
              nos activit&eacute;s. Nous faisons le choix d&apos;une IA
              responsable, fond&eacute;e sur un contr&ocirc;le humain, une
              vigilance face aux risques de biais, une protection exigeante des
              donn&eacute;es et une transparence sur les usages de ces
              technologies. Pour nous, l&apos;innovation n&apos;a de sens que
              lorsqu&apos;elle renforce la confiance et cr&eacute;e une valeur
              durable.
            </div>
          
            <div>
              Nous poursuivons &eacute;galement notre d&eacute;marche de
              r&eacute;duction de notre empreinte environnementale &agrave;
              travers le d&eacute;veloppement de pratiques de
              sobri&eacute;t&eacute; num&eacute;rique et de Green IT, la
              r&eacute;alisation de notre bilan carbone, une politique
              d&apos;achats responsables et des actions concr&egrave;tes visant
              &agrave; limiter l&apos;impact environnemental de nos
              activit&eacute;s.
            </div>
          
            <div>
              Les d&eacute;fis &eacute;conomiques, environnementaux et
              technologiques continueront d&apos;&eacute;voluer. Notre ambition
              est de faire grandir Worldata Team en conciliant innovation,
              responsabilit&eacute; et performance durable.
            </div>
          
            <div>
              En renouvelant notre soutien aux 10 principes du Pacte mondial des
              Nations Unies, nous affirmons notre volont&eacute; de poursuivre
              cette d&eacute;marche avec exigence, transparence et
              humilit&eacute;, aux c&ocirc;t&eacute;s de nos collaborateurs, de
              nos clients et de nos partenaires, afin de contribuer &agrave; un
              num&eacute;rique plus responsable, plus durable et plus humain.
            </div>
          
            <div class="tw-font-semibold tw-italic">
              Ahmed Ben Amor<br />Directeur g&eacute;n&eacute;ral de Worldata Team
            </div>
          </div>
        </template>
      </CardWithLineGeneric>
    </div>
  </div>
</template>

<script>
import { APP_NAME, APP_EMAIL } from "../../statics/app_static";
import { fetchCmsPublicPage, interpolateCmsText } from "../../statics/cms";
import CardWithLineGeneric from "../generics/Cards/CardWithLine/CardWithLineGeneric.vue";
import SimpleSectionHeader from "../generics/Headers/SimpleSectionHeader/SimpleSectionHeader.vue";

export default {
  name: "PolitiquesConfidentialite",
  components: {
    SimpleSectionHeader,
    CardWithLineGeneric,
  },
  data() {
    return {
      APP_NAME,
      APP_EMAIL,
      isLoading: false,
      texts: [],
      pageTitle: "POLITIQUE DE CONFIDENTIALITE",
    };
  },
  mounted() {
    this.loadCmsTexts();
  },
  methods: {
    async loadCmsTexts() {
      this.isLoading = true;
      try {
        const { pageLabel, texts } = await fetchCmsPublicPage(
          "politiques-confidentialite",
        );
        this.texts = texts;
        if (pageLabel) {
          this.pageTitle = String(pageLabel).toUpperCase();
        }
      } catch {
        this.texts = [];
      } finally {
        this.isLoading = false;
      }
    },
    interpolateDynamicText(text) {
      return interpolateCmsText(text, {
        APP_NAME: this.APP_NAME,
        APP_EMAIL: this.APP_EMAIL,
      });
    },
  },
};
</script>
